window.vdpAddToCart = function(pid, variantId) {

  var btn = document.getElementById('vdp-atc-btn-' + pid);

  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt...';
  }

  // ❗ Validate variantId early
  if (!variantId) {
    console.error("Missing variantId for product:", pid);

    if (btn) {
      btn.disabled = false;
      btn.textContent = 'In den Warenkorb legen';
    }
    return;
  }

  /*console.log("Adding to cart →", {
    productId: pid,
    variantId: variantId
  });*/

  // ✅ Safer Shopify request (FormData avoids many Safari issues)
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(async (res) => {
      const data = await res.json().catch(() => null);

      if (!res.ok) {
        console.error("Cart error:", data || res.statusText);
        throw data || new Error("Add to cart failed");
      }

      return data;
    })
    .then(data => {
      //console.log('Added to cart:', data);

      // ✅ Refresh cart state
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cart => {
      //console.log('Cart updated:', cart);

      // 🔥 Open cart drawer (theme safe triggers)

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:open', { bubbles: true })
      );

      document.dispatchEvent(
        new CustomEvent('cart:open', { bubbles: true })
      );

      // Shopify Dawn / Horizon fallback
      document.querySelector('cart-drawer')?.open?.();

    })
    .catch(err => {
      console.error('Add to cart failed:', err);
    })
    .finally(() => {
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'In den Warenkorb legen';
      }
    });
};